'use client';

/**
 * Installation CTA Component
 *
 * Full-width banner with "Need Installation?" messaging
 * Features the DIY/Install background image with text overlay in the center
 * Positioned above Product Details tabs on product pages
 */
import { c as _c } from "react/compiler-runtime";
import Image from '@/components/media/StorefrontImage';
import Link from 'next/link';
export function InstallationCTA() {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Image src="https://scw-commerce-media.s3.amazonaws.com/pub/media/images/diy-or-install3.png" alt="DIY or Professional Installation" className="installation-cta-bg" width={1200} height={400} sizes="100vw" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="installation-cta-subheading">Need Installation?</span>;
    t2 = <h2 className="installation-cta-heading">No Problem</h2>;
    t3 = <p className="installation-cta-description">Whether you plan to DIY install or want us to do it for you, we're as flexible as you need.</p>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="installation-cta"><div className="installation-cta-container">{t0}<div className="installation-cta-content">{t1}{t2}{t3}<p className="installation-cta-action">Get a{" "}<Link href="/get-a-quote" className="installation-cta-button">Custom Quote</Link>{" "}for Equipment or Installation</p></div></div></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}